<template>
  <hic-list-page :entities="entities" :condition="condition" @load="query(true)" @selection-change="selectChange" :loading="meta.loading" :title="isEmbed ? '' : '药品'" :header-height="!readonly ? '6rem' : ''" keyword-placeholder="药品名称、编码">
    <template v-if="!readonly" slot="buttons">
      <el-button v-if="tabName == '待发送' && isApply" @click="apply(true)" type="primary" size="small" icon="el-icon-top-right">申请发药</el-button>
      <el-button v-if="tabName == '待执行'" @click="apply(false)" type="warning" size="small" icon="el-icon-bottom-left">撤回发药申请</el-button>
      <el-button v-if="tabName == '已执行' && !setting.isSimple" @click="refund" type="danger" size="small" icon="el-icon-close" :disabled="!selection.length" key="refund">申请退药</el-button>
      <el-button v-if="tabName == '待退费'" @click="cancelRefund" type="danger" size="small" icon="el-icon-close" :disabled="!selection.length" key="refund">撤回退药申请</el-button>
      <el-button @click="meta.showSum = true" type="success" size="small" icon="el-icon-pie-chart">汇总</el-button>
    </template>
    <template slot="search">
      <el-select v-if="!isEmbed" v-model="condition.ipNos" placeholder="请选择患者" @change="query" clearable size="small" class="right-pad" multiple collapse-tags filterable>
        <el-option v-for="item in patients" :key="item.id" :value="item.ipNo">{{ item.bedNo }} {{ item.patientName }} {{ item.patientGender | dictText("Gender") }} {{ item.patientAge }}</el-option>
      </el-select>
      <el-date-picker v-if="tabName == '待执行'" v-model="meta.date" @change="dateChange" size="small" type="date" style="width: 140px" placeholder="日期"></el-date-picker>
      <el-date-picker v-else @change="dateChange" v-model="meta.dateRange" style="width: 270px" size="small" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" placeholder="开单日期"></el-date-picker>
    </template>
    <template v-if="!readonly" slot="extend">
      <el-tabs v-model="tabName" @tab-click="tabChange">
        <el-tab-pane label="待发送" name="待发送"></el-tab-pane>
        <el-tab-pane label="已发送" name="待执行"></el-tab-pane>
        <el-tab-pane label="已发药" name="已执行"></el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="待退药" name="待退费"></el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="已退药" name="已退费"></el-tab-pane>
        <el-tab-pane label="全部" name="全部"></el-tab-pane>
      </el-tabs>
    </template>
    <template v-if="!readonly">
      <el-table-column type="selection" width="55" key="selection"></el-table-column>
    </template>
    <template v-if="!isEmbed">
      <el-table-column label="床位号" prop="bedNo" width="100" sortable="custom" key="bedNo"></el-table-column>
      <el-table-column label="患者姓名" prop="patientName" width="130" key="patientName">
        <template #default="{ row }">
          <span class="sub-title">{{ row.patientName }}</span>
        </template>
      </el-table-column>
    </template>
    <el-table-column label="药品名称" prop="name" min-width="200" key="name">
      <template #default="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="规格" prop="standard" min-width="150" key="standard"> </el-table-column>
    <el-table-column label="数量" align="right" prop="quantity" width="100" key="quantity">
      <template #default="{ row }">
        <span class="danger">{{ row.quantity }} {{ row.unit }}</span>
      </template>
    </el-table-column>
    <el-table-column label="频次" align="center" prop="frequency" width="180" key="frequency">
      <template slot-scope="{ row }">
        {{ row.advice.frequency | dictText("DrugFrequency") }}
      </template>
    </el-table-column>
    <el-table-column label="厂商" prop="manufacturerCode" width="100" show-overflow-tooltip key="manufacturerCode" />
    <el-table-column label="批次" prop="lotNumber" width="100" key="lotNumber" />
    <el-table-column label="单价" align="right" prop="price" width="100" key="price">
      <template #default="{ row }">
        <span>{{ row.quantity | fmtFloat(2) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="药房" align="center" prop="storehouseCode" width="130" key="storehouseCode">
      <template slot-scope="{ row }">
        {{ row.storehouseCode | dictText("Storehouse") }}
      </template>
    </el-table-column>
    <el-table-column label="剂型" align="center" prop="" width="80" key="form">
      <template slot-scope="{ row }">
        {{ row.form | dictText("DrugForm") }}
      </template>
    </el-table-column>
    <el-table-column label="记账人" align="center" prop="billingUserName" width="100" key="billingUserName"> </el-table-column>
    <el-table-column label="记账日期" align="center" prop="" width="120" key="billingDate">
      <template slot-scope="{ row }">
        <div>{{ row.billingDate | fmtDate }}</div>
      </template>
    </el-table-column>
    <el-table-column label="医嘱医生" prop="doctorName" width="120px" key="doctorName"> </el-table-column>
    <template v-if="tabName == '已发药'">
      <el-table-column label="摆药单号" align="center" prop="no" width="150"></el-table-column>

      <!---下面药房的人，不一定要用--->
      <el-table-column label="发药人" align="center" prop="doctorName" width="120px"> </el-table-column>
      <el-table-column label="发药时间" align="center" prop="" width="180px">
        <template slot-scope="{ row }">
          <div>{{ row.adviceTime | fmtDate }}</div>
        </template>
      </el-table-column>
    </template>
    <template v-if="tabName == '已退药'">
      <!---下面药房的人，不一定要用--->
      <el-table-column label="退药人" align="center" prop="refundNurseName" width="120" key="refundNurseName"> </el-table-column>
      <el-table-column label="退药时间" align="center" prop="" width="120" key="refundTime">
        <template slot-scope="{ row }">
          <div>{{ row.refundTime | fmtDate }}</div>
        </template>
      </el-table-column>
    </template>
    <DialogSum :visible.sync="meta.showSum" :condition="condition" />"
  </hic-list-page>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  const getTodayDate = ()=> {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  const getYesterday = ()=> {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    
    // 格式化日期为 YYYY-MM-DD
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    return formatDate(yesterday);
  }
  export default {
    props: {
      entity: Object, // 住院记录
    },
    components: {
      DialogSum: () => import("./dlgSum"),
    },
    data() {
      return {
        tabName: "待发送",
        meta: {
          loading: false,
          date: getTodayDate(),
          dateRange: [getYesterday(),getTodayDate()],
          showSum: false,
        },
        condition: {
          rpClasses: ["药品", "草药"],
          disabled: false,
          sort: "bedNo",
          asc: true,
          pageSize: 100,
          billingDateStart: getYesterday(),
          billingDateEnd: getTodayDate(),
          state: null,
          keyword: null,
          ipNos: [],
          ifJoinSearch:true
        },
        entities: {},
        selection: [],
        patients: [],
        ipNo: null,
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum", "user", "setting"]),
      isEmbed() {
        // 是否是嵌入模式
        return this.$route.path != "/drug";
      },
      readonly() {
        return this.entity?.state == "已离院" || this.entity?.state == "已结算";
      },
      isApply() {
        if (this.setting.adviceExecInfo) {
          return !(JSON.parse(this.setting.adviceExecInfo).ifExecApplyDrug);
        } else {
          return true;
        }
      },
    },
    watch: {
      entity() {
        this.query();
      },
    },
    mounted() {
      
      if (!this.isEmbed) {
        api.Hospitalization.query({ deptCode: this.user.deptCode, state: "已入住" ,sort: "bedNo",asc: true,})
          .then((res) => {
            this.patients = res.items;
          })
          .finally(() => {});
      }

      // this.meta.date = this.$utils.Fmt.date(new Date());
      // this.dateChange(this.meta.date);
      // this.query();
    },
    methods: {
      tabChange(v) {
        this.date = null;
        this.day = "";
        this.condition.keyword = null;

        this.query();
      },
      selectChange(val) {
        this.selection = val;
      },
      dateChange(v) {
        if (v) {
          if (Array.isArray(v)) {
            this.condition.billingDateStart = this.$utils.Fmt.date(v[0]);
            this.condition.billingDateEnd = this.$utils.Fmt.date(v[1]);
          } else {
            this.condition.billingDateStart = this.$utils.Fmt.date(v);
            this.condition.billingDateEnd = this.$utils.Fmt.date(v);
          }
        } else {
          this.condition.billingDateStart = null;
          this.condition.billingDateEnd = null;
        }
        this.query();
      },
      query() {
        this.meta.loading = true;
        this.condition.deptCode = this.user.deptCode;
        if(this.tabName == '全部') delete this.condition.state
        else this.condition.state = this.tabName
        
        if (this.entity) {
          this.condition.hospitalizationId = this.entity.id;
        }
        api.Billing.query(this.condition)
          .then((res) => {
            this.$set(this, "entities", res);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      apply(isSend) {
        let con = null;
        if (this.selection.length) {
          con = { ids: this.selection.map((item) => item.id) };
        } else {
          con = this.$utils.Obj.clone(this.condition);
          delete con.pageSize;
          delete con.pageIndex;
        }
        if (isSend) {
          api.Billing.drugApply(con).then((res) => {
            this.query();
          });
          return;
        }
        api.Billing.drugCancelApply(con).then((res) => {
          this.query();
        });
      },
      refund() {
        if (this.selection.length == 0) {
          this.$message.error("请选择要退药的药品");
          return;
        }
        this.$prompt("请输入退药原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /\S/,
          inputErrorMessage: "请输入退药原因",
        }).then(({ value }) => {
          api.Billing.drugRefund({
            ids: this.selection.map((item) => item.id),
            refundReason: value,
          }).then((res) => {
            this.query();
          });
        });
      },
      cancelRefund() {
        if (this.selection.length == 0) {
          this.$message.error("请选择要取消退药的药品");
          return;
        }
        api.Billing.drugCancelRefund({ ids: this.selection.map((item) => item.id) }).then((res) => {
          this.query();
        });
      },
    },
  };
</script>
